export const LISTING_MIN_HEIGHT = 600;
